export var IdentityStateKeys;
(function (IdentityStateKeys) {
    IdentityStateKeys["BIO_METRIC_CHECK"] = "bioMetricCheck";
    IdentityStateKeys["CAPTURE_PHOTO_RESPONSE"] = "capturePhotoResponse";
    IdentityStateKeys["COUNTRY"] = "country";
    IdentityStateKeys["DOCUMENT_OPTION"] = "documentOption";
    IdentityStateKeys["IDV_DATA"] = "idvSaveData";
    IdentityStateKeys["INDIVIDUAL_DATA"] = "individualData";
})(IdentityStateKeys || (IdentityStateKeys = {}));
//# sourceMappingURL=identityConfig.js.map